import { render } from "./CustomerDetail.vue?vue&type=template&id=3bbd333e&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import "./CustomerDetail.vue?vue&type=style&index=0&id=3bbd333e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbd333e"],['__file',"src/views/h5/common/basedata/partner/customer/CustomerDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bbd333e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bbd333e', __exports__)) {
    api.reload('3bbd333e', __exports__)
  }
  
  module.hot.accept("./CustomerDetail.vue?vue&type=template&id=3bbd333e&scoped=true", () => {
    api.rerender('3bbd333e', render)
  })

}


export default __exports__